import { FC, ReactNode, ChangeEventHandler } from 'react';
import getTestId from '@functions/testId';

type Props = {
    name?: string;
    text: string | ReactNode;
    value?: boolean;
    testId?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    onBlur?: ChangeEventHandler<HTMLInputElement>;
};

const Checkbox: FC<Props> = ({ name, text, value, testId, onChange, onBlur }) => {
    return (
        <label
            className="tw-group/checkbox tw-relative tw-my-2 tw-mb-3 tw-block tw-cursor-pointer tw-select-none tw-pl-[35px] tw-text-base hover:[&>input~span]:tw-border-teal-600"
            data-testid={getTestId(testId)}
        >
            <span className="![&>a]:tw-text-xs ![&>a]:tw-leading-[.8rem] md:tw-leading[1.1rem] !md:[&>a]:tw-text-base !md:[&>a]:tw-leading-[1.1rem] tw-text-xs tw-leading-[0.8rem] md:tw-text-base">
                {text}
            </span>
            <input
                name={name}
                type="checkbox"
                className={'tw-peer/input_checkbox tw-absolute tw-h-0 tw-w-0 tw-cursor-pointer tw-opacity-0'}
                onChange={onChange}
                onBlur={onBlur}
                checked={value}
            />
            <span className="tw-absolute tw-left-0 tw-top-0 tw-h-[25px] tw-w-[25px] tw-rounded tw-border tw-border-solid tw-border-grey-500 tw-bg-white after:tw-absolute after:tw-left-2 after:tw-top-[3px] after:tw-hidden after:tw-h-3.5 after:tw-w-2 after:tw-rotate-45 after:tw-border-b-[3px] after:tw-border-l-0 after:tw-border-r-[3px] after:tw-border-t-0 after:tw-border-solid after:tw-border-white after:tw-content-[''] group-hover/checkbox:tw-border-teal-600 group-hover/checkbox:!tw-bg-teal-100 group-hover/checkbox:tw-bg-white group-hover/checkbox:after:tw-border-teal-600 peer-checked/input_checkbox:tw-border-teal-600 peer-checked/input_checkbox:tw-bg-teal-600 peer-checked/input_checkbox:after:tw-block" />
        </label>
    );
};

export default Checkbox;
